/**
 * Check if user can perform a specific action or view a page
 * @param {string} requiredPermission - The exact permission needed (e.g., 'Books', 'Questions.Manage')
 * @param {Array<string>} userPermissions - Array of user's permission strings
 * @returns {boolean}
 */
export function canPerformAction(requiredPermission, userPermissions) {
  return userPermissions.includes(requiredPermission);
}
